module.exports = __webpack_public_path__ + "static/media/2H.ebe43495.png";